import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { AxiosError } from 'axios';
import isEmail from 'validator/es/lib/isEmail';
import isEthereumAddress from 'validator/es/lib/isEthereumAddress';
import { validatePassword } from '../../common/passwordValidator';
import LandingTemplate from '../LandingTemplate';
import { useAuth } from '../../common/auth';
import { IFormInput } from '../Form';

export default function SignUp() {
  const formHook = useForm();
  const { setError } = formHook;
  const { signUp } = useAuth();

  const [signUpSucceeded, setSignUpSucceeded] = useState(false);

  const inputs: IFormInput[] = [
      {
        name: 'name',
        label: 'User or Organization Name',
        required: true
      },
      {
        name: 'email',
        label: 'Email Address',
        type: 'email',
        validate: {
          email: value => isEmail(value)
        },
        required: true
      },
      {
        name: 'password',
        label: 'Password',
        type: 'password',
        validate: {
          password: value => validatePassword(value)
        },
        required: true
      },
      {
        name: 'platform',
        label: 'Platform/App Name',
        required: true
      },
      {
        name: 'website',
        label: 'Website & Mobile App Links',
        required: true
      },
      {
        name: 'ethereumAddress',
        label: 'Ethereum address',
        validate: {
          'ethereumAddress': value => isEthereumAddress(value)
        },
        required: true
      }
    ];

  function onSubmit(data: any) {
    signUp(data)
      .then(() => setSignUpSucceeded(true))
      .catch(processError);
  };

  function processError(error: AxiosError) {
    const { response } = error;

    if (response?.status === 409) {
      const { field } = response.data;

      setError(field, {
        message: `${field}IsAlreadyUsed`
      });

      return;
    }
  }

  const registrationCompletedMessage = 'Thank you for your registration! Please check you mailbox to confirm your email.';

  return <LandingTemplate
    form={{
      submitCaption: "Sign Up",
      inputs,
      onSubmit,
      formHook
    }}
    successFullSubmitMessage={(signUpSucceeded && registrationCompletedMessage) || undefined}
  />;
}